module.exports = __webpack_public_path__ + "img/who_makes_the_web_interesting.584a3ec0.svg";